/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, next: NonNullable<unknown> }} Plan_Edit_Superset_LinkInputs */

const en_us2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Group ${i?.name} and ${i?.next} as a superset`)
};

const pt_br2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Juntar ${i?.name} e ${i?.next} em superset`)
};

const es_419_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agrupar ${i?.name} y ${i?.next} en superserie`)
};

const pt_pt2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Juntar ${i?.name} e ${i?.next} em superset`)
};

const fr_fr2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grouper ${i?.name} et ${i?.next} en superset`)
};

const de_de2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} und ${i?.next} als Supersatz verbinden`)
};

const it_it2_plan_edit_superset_link = /** @type {(inputs: Plan_Edit_Superset_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unisci ${i?.name} e ${i?.next} in un superset`)
};

/**
* | output |
* | --- |
* | "Group {name} and {next} as a superset" |
*
* @param {Plan_Edit_Superset_LinkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_superset_link = /** @type {((inputs: Plan_Edit_Superset_LinkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Superset_LinkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_superset_link(inputs)
	if (locale === "es-419") return es_419_plan_edit_superset_link(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_superset_link(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_superset_link(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_superset_link(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_superset_link(inputs)
	return en_us2_plan_edit_superset_link(inputs)
});
export { plan_edit_superset_link as "plan-edit.superset_link" }